import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Pressable, Text, View } from 'react-native';
import { Checkbox } from 'LocalGluons';
import { t } from 'Locale/index';

import { defaultStyles, landscapeStyles } from './RecordPlatformSelector.jss';

const checkboxHitSlop = {
    top: 5,
    bottom: 5,
    left: 10,
    right: 200
};

export const RecordPlatformSelector = ({ isLandscape, onGoPress, onIptvPress }) => {
    const styles = isLandscape ? landscapeStyles : defaultStyles;
    const [iptvPressed, setIptvPressed] = useState(false);
    const [goPressed, setGoPressed] = useState(true);

    const onIptvPressed = () => {
        setIptvPressed(!iptvPressed);
        onIptvPress();
    };

    const onGoPressed = () => {
        setGoPressed(!goPressed);
        onGoPress();
    };

    return (
        <View style={styles.container}>
            <View style={styles.platformContainer}>
                <Checkbox checked={iptvPressed} hitSlop={checkboxHitSlop} onPress={onIptvPressed} />
                <Pressable onPress={onIptvPressed}>
                    <Text style={styles.recPlatform}>{t('COMMON.REC_PLATFORM_IPTV')}</Text>
                </Pressable>
            </View>
            <View style={styles.platformContainer}>
                <Checkbox checked={goPressed} hitSlop={checkboxHitSlop} onPress={onGoPressed} />
                <Pressable onPress={onGoPressed}>
                    <Text style={styles.recPlatform}>{t('COMMON.REC_PLATFORM_OTT')}</Text>
                </Pressable>
            </View>
        </View>
    );
};

RecordPlatformSelector.propTypes = {
    onGoPress: PropTypes.func.isRequired,
    onIptvPress: PropTypes.func.isRequired,
    isLandscape: PropTypes.bool.isRequired
};
